import { playLottie, loopPlayLottie } from './lottie'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)


// for using add class lazy to img, div or iframe and add data-img-src/medium/large attributes with urls

let imgSize = 'data-img-src'
if (window.innerWidth <= 600) {
  imgSize = 'data-img-phone'
} else if (window.innerWidth <= 1024) {
  imgSize = 'data-img-tablet'
} else if (window.innerWidth > 2000) {
  imgSize = 'data-img-x2'
}
let last_scroll_top = window.scrollY - 1

let vH = window.innerHeight


// global function for using in popups or after ajax
function loadElementLazyImage(elements) {
  elements.each(function () {
    let imgSrc = this.getAttribute(imgSize)
    if (!imgSrc) { imgSrc = this.getAttribute('data-img-src') }

    if (!this.classList.contains('loaded') && imgSrc) {
      let nodName = this['nodeName']
      let position = this.getAttribute('data-img-position')
      if (!position) position = 'center'

      if (nodName !== 'IMG' && nodName !== 'IFRAME' && nodName !== 'VIDEO') {
        this.style.background = 'url(' + imgSrc + ') no-repeat ' + position
        this.style.backgroundSize = 'cover'
      } else {
        if (nodName === 'VIDEO') {
          this.querySelector('source').setAttribute('src', imgSrc)
          this.load()
        } else {
          this.setAttribute('src', imgSrc)
        }
      }

      this.classList.add('loaded')
    }

  })
}


// let lazyImagesArr = [...document.querySelectorAll('.lazy')]
// function loadLazyImages () {
//   if (lazyImagesArr.length) {
//     lazyImagesArr.forEach(function (el, i) {
//       if (isScrolledIntoView(el, 400) && el.offsetParent !== null && !el.classList.contains('load-later')) {
//         loadElementLazyImage($(el))
//         lazyImagesArr.splice(i, 1)
//       }
//     })
//   }
// }

document.querySelectorAll('.lazy').forEach(function (el) {
  ScrollTrigger.create({
    trigger: el,
    start: "top bottom+=400px", // el top, screen bottom
    once: true,
    onEnter: () => loadElementLazyImage($(el))
  });
})



// check if in screeen
function isScrolledIntoView(el, offset) {
  let elPos = el.getBoundingClientRect()

  let docViewTop = window.scrollY
  let docViewBottom = docViewTop + vH
  let elemTop = elPos.top + + el.ownerDocument.defaultView.pageYOffset - offset
  let elemBottom = elemTop + elPos.height + (offset * 2)

  if (last_scroll_top < docViewTop) {
    return ((elemBottom >= docViewTop) && (elemTop <= docViewBottom))
  } else {
    return ((elemBottom >= docViewTop) && (elemTop <= docViewTop))
  }
}

// check if scrolled to element from top
//      class: js-add-class-when-in-screen
//      data-add-class="change-colors"
//      data-screen-offset="300"
//      data-screen-pos="top"
export function checkIfInScreen(el){
  let docViewTop = window.scrollY
  let docViewBottom = docViewTop + vH
  let elTop = el.getBoundingClientRect().top + el.ownerDocument.defaultView.pageYOffset
  let elScreenPosition = el.getAttribute('data-screen-pos') ? el.getAttribute('data-screen-pos') : 'bottom'
  let offset = el.getAttribute('data-screen-offset') ? el.getAttribute('data-screen-offset') : 0

  if (elScreenPosition === 'top'){
    if (docViewTop > elTop - offset){
      return true
    }
  } else {
    if (docViewBottom > elTop - offset) {
      return true
    }
  }
  return false
}


// add element class when scrolled in screen
//      class: js-add-class-when-in-screen
//      data-add-class="change-colors"
//      data-screen-offset="300"
//      data-screen-pos="top"
//      data-add-class-repeat="true"
let addClassArr = [...document.querySelectorAll('.js-add-class-when-in-screen')]
function addClassWhenInScreen() {
  addClassArr.forEach(function (el, i) {
    let addClass = el.getAttribute('data-add-class') ? el.getAttribute('data-add-class') : 'js-in-screen';
    if (addClass) {
      if (checkIfInScreen(el)) {
        el.classList.add(addClass)
        if (!el.getAttribute('add-class-repeat')) {
          el.classList.add('js-added-class')
          addClassArr.splice(i, 1)
        }
      } else {
        if (!el.classList.contains('js-added-class')) el.classList.remove(addClass)
      }
    }
  })
}




// let loadLottieArr = [...document.querySelectorAll('.js-play-lottie-on-scrolled')]
// export function loadLottieFiles () {
//   console.log('test')
//   if (loadLottieArr.length) {
//     loadLottieArr.forEach(function (el, i) {
//       let loadOffset = el.getAttribute('data-load-offset') ? el.getAttribute('data-load-offset') : '-100'
//       let loopPlay = el.getAttribute('data-loop-play') ? el.getAttribute('data-loop-play') : false
//
//       if (isScrolledIntoView(el, loadOffset) && el.offsetParent !== null && !el.classList.contains('load-later') && !el.classList.contains('played')) {
//         if (loopPlay) {
//           loopPlayLottie($(el))
//         } else {
//           playLottie($(el))
//         }
//         el.classList.add('played')
//
//         loadLottieArr.splice(i, 1)
//       }
//     })
//   }
// }


// Play Lottie
export function loadLottieFiles () {
  document.querySelectorAll('.js-play-lottie-on-scrolled').forEach(function (el) {
    let loadOffset = el.getAttribute('data-load-offset') ? el.getAttribute('data-load-offset') : '100'
    ScrollTrigger.create({
      trigger: el,
      start: "top bottom-=" + loadOffset + "px", // el top, screen bottom
      once: true,
      onEnter: () => {
        let loopPlay = el.getAttribute('data-loop-play') ? el.getAttribute('data-loop-play') : false
        if (loopPlay) {
          loopPlayLottie($(el))
        } else {
          playLottie($(el))
        }
        el.classList.add('played')
      }
    });
  })
}





// activate on
$(window).scroll(function () {
  //loadLazyImages()
  //loadLottieFiles()
  addClassWhenInScreen()
  last_scroll_top = window.scrollY
})
$(window).resize(()=> {  })

$(window).on('load', function (){
  //loadLazyImages()
  addClassWhenInScreen()
})

export { loadElementLazyImage, isScrolledIntoView}
